// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер для кошки */
.cat-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

/* Основной элемент кошки */
.cat {
  position: absolute;
  width: 80px;
  height: 60px;
  pointer-events: auto;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: center;
}

/* Состояние "показывает сообщение" - кошка более спокойная */
.cat--showing-message {
  cursor: default;
  pointer-events: none !important;
}

.cat--showing-message .cat-body {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cat--showing-message .cat-head {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Тело кошки - минималистичный дизайн */
.cat-body {
  position: relative;
  width: 100%;
  height: 100%;
  background: #2c3e50;
  border-radius: 30px 30px 20px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  /* overflow: hidden; */
}

/* Полоски на теле */
.cat-body::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(90deg, transparent 0%, transparent 20%, #34495e 20%, #34495e 25%, transparent 25%, transparent 45%, #34495e 45%, #34495e 50%, transparent 50%, transparent 70%, #34495e 70%, #34495e 75%, transparent 75%, transparent 100%);
  background-size: 100% 8px;
  background-position: 0 15px;
  opacity: 0.6;
}

/* Голова кошки */
.cat-head {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-100%);
  width: 45px;
  height: 35px;
  background: #2c3e50;
  border-radius: 22px 22px 18px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  /* overflow: hidden; */
}

/* Полоски на голове */
/* .cat-head::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(90deg, transparent 0%, transparent 30%, #34495e 30%, #34495e 35%, transparent 35%, transparent 65%, #34495e 65%, #34495e 70%, transparent 70%, transparent 100%);
  background-size: 100% 6px;
  background-position: 0 8px;
  opacity: 0.6;
} */

/* Уши кошки - треугольные */
.cat-ears {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 25px;
}

.cat-ear {
  position: absolute;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 22px solid #34495e;
  border-radius: 2px;
  transition: transform 0.3s ease;
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3); */
  filter: brightness(1.1);
}

.cat-ear::before {
  content: '';
  position: absolute;
  top: 3px;
  left: -8px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 14px solid #e74c3c;
  border-radius: 1px;
}

.cat-ear--left {
  left: 2px;
  transform: rotate(-25deg);
}

.cat-ear--right {
  right: 2px;
  transform: rotate(25deg);
}

/* Анимация ушек при hover */
.cat:hover .cat-ear--left {
  transform: rotate(-30deg) scale(1.1);
}

.cat:hover .cat-ear--right {
  transform: rotate(30deg) scale(1.1);
}

/* Анимация ушек при разных состояниях */
.cat--grooming .cat-ear--left {
  animation: earTwitch 0.5s ease-in-out infinite;
}

.cat--grooming .cat-ear--right {
  animation: earTwitchRight 0.5s ease-in-out infinite 0.25s;
}

.cat--sleeping .cat-ear--left {
  transform: rotate(-15deg);
}

.cat--sleeping .cat-ear--right {
  transform: rotate(15deg);
}

@keyframes earTwitch {
  0%, 100% { transform: rotate(-25deg); }
  50% { transform: rotate(-35deg); }
}

@keyframes earTwitchRight {
  0%, 100% { transform: rotate(25deg); }
  50% { transform: rotate(35deg); }
}

/* Лицо кошки */
.cat-face {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 18px;
}

/* Глаза кошки - большие и круглые */
.cat-eyes {
  position: relative;
  width: 100%;
  height: 12px;
}

.cat-eye {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #ecf0f1;
  border-radius: 50%;
  top: 1px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
  /* position: relative;
  overflow: hidden; */
}

.cat-eye::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 4px;
  height: 4px;
  background: #2c3e50;
  border-radius: 50%;
  animation: blink 3s ease-in-out infinite;
}

@keyframes blink {
  0%, 90%, 100% { transform: scaleY(1); }
  95% { transform: scaleY(0.1); }
}

.cat-eye--left {
  left: 2px;
}

.cat-eye--right {
  right: 2px;
}

/* Нос кошки */
.cat-nose {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 3px;
  background: #e74c3c;
  border-radius: 50%;
}

/* Рот кошки */
.cat-mouth {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 2px;
  border-bottom: 1px solid #34495e;
  border-radius: 0 0 3px 3px;
}

/* Усы кошки - тонкие линии */
/* .cat-whiskers {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 15px;
} */

/* .cat-whisker {
  position: absolute;
  width: 15px;
  height: 1px;
  background: #bdc3c7;
  border-radius: 1px;
  transition: all 0.3s ease;
} */

/* .cat-whisker--left-1 { top: 2px; left: -12px; transform: rotate(-15deg); }
.cat-whisker--left-2 { top: 7px; left: -12px; transform: rotate(-5deg); }
.cat-whisker--left-3 { top: 12px; left: -12px; transform: rotate(5deg); }
.cat-whisker--right-1 { top: 2px; right: -12px; transform: rotate(15deg); }
.cat-whisker--right-2 { top: 7px; right: -12px; transform: rotate(5deg); }
.cat-whisker--right-3 { top: 12px; right: -12px; transform: rotate(-5deg); } */

/* Хвост кошки - изогнутый */
.cat-tail {
  position: absolute;
  top: 12px;
  right: -22px;
  width: 30px;
  height: 6px;
  background: #2c3e50;
  border-radius: 3px;
  transform-origin: left center;
  animation: tailWag 2s ease-in-out infinite;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* .cat-tail::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(90deg, transparent 0%, transparent 30%, #34495e 30%, #34495e 35%, transparent 35%, transparent 65%, #34495e 65%, #34495e 70%, transparent 70%, transparent 100%);
  background-size: 100% 3px;
  background-position: 0 2px;
  opacity: 0.6;
  border-radius: 3px;
} */

.cat-tail-tip {
  position: absolute;
  right: -4px;
  top: -2px;
  width: 6px;
  height: 6px;
  background: #2c3e50;
  border-radius: 50%;
}

/* Лапы кошки */
.cat-paws {
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 8px;
}

.cat-paw {
  position: absolute;
  width: 8px;
  height: 6px;
  background: #2c3e50;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cat-paw--front-left {
  left: 15px;
  bottom: 0;
}

.cat-paw--front-right {
  left: 25px;
  bottom: 0;
}

.cat-paw--back-left {
  right: 25px;
  bottom: 0;
}

.cat-paw--back-right {
  right: 15px;
  bottom: 0;
}

/* Анимация виляния хвостом */
@keyframes tailWag {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(8deg); }
}

/* Состояние сидения */
.cat--sitting {
  animation: sitting 4s ease-in-out infinite;
}

@keyframes sitting {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-2px); }
}

/* Состояние вылизывания */
.cat--grooming {
  animation: grooming 1.5s ease-in-out infinite;
}

@keyframes grooming {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-8deg); }
  75% { transform: rotate(8deg); }
}

/* Язык для вылизывания */
.cat-tongue {
  position: absolute;
  top: 14px;
  left: 25%;
  transform: translateX(-100%);
  width: 4px;
  height: 6px;
  background: #e91e63;
  border-radius: 0 0 2px 2px;
  animation: tongueLick 0.6s ease-in-out infinite;
}

@keyframes tongueLick {
  0%, 100% { height: 6px; }
  50% { height: 10px; }
}

/* Лапа для вылизывания */
/* .cat-paw-grooming {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 8px;
  background: #2c3e50;
  border-radius: 3px;
  animation: pawGroom 1.5s ease-in-out infinite;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@keyframes pawGroom {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(45deg); }
} */

/* Состояние сна */
.cat--sleeping {
  animation: sleeping 5s ease-in-out infinite;
}

@keyframes sleeping {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

/* Глаза во время сна */
.cat--sleeping .cat-eye {
  background: #95a5a6;
  border-radius: 50% 50% 0 0;
  height: 5px;
  animation: eyeSleep 3s ease-in-out infinite;
}

@keyframes eyeSleep {
  0%, 100% { height: 5px; }
  50% { height: 2px; }
}

/* ZZZ для сна */
.cat-sleeping {
  position: absolute;
  top: -25px;
  right: -8px;
  font-size: 14px;
  font-weight: bold;
  color: #3498db;
  animation: zzzFloat 2s ease-in-out infinite;
}

.cat-zzz {
  position: absolute;
  animation: zzzFloat 2s ease-in-out infinite;
}

.cat-zzz--2 {
  animation-delay: 0.5s;
  top: -15px;
  right: 5px;
}

.cat-zzz--3 {
  animation-delay: 1s;
  top: -8px;
  right: 15px;
}

@keyframes zzzFloat {
  0%, 100% { 
    opacity: 0.6;
    transform: translateY(0px) rotate(0deg);
  }
  50% { 
    opacity: 1;
    transform: translateY(-5px) rotate(5deg);
  }
}

/* Состояние бега */
.cat--running {
  animation: running 0.3s ease-in-out infinite;
}

@keyframes running {
  0%, 100% { transform: translateY(0px); }
  25% { transform: translateY(-3px); }
  75% { transform: translateY(2px); }
}

/* Анимация лап при беге */
.cat--running .cat-paw {
  animation: pawRun 0.3s ease-in-out infinite;
}

.cat--running .cat-paw--front-left,
.cat--running .cat-paw--back-right {
  animation-delay: 0.15s;
}

@keyframes pawRun {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-2px); }
}

/* Прогресс-бары */
.cat-progress {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 4px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  overflow: hidden;
}

.cat-progress-bar {
  height: 100%;
  border-radius: 2px;
  transition: width 0.1s ease;
}

.cat-progress-bar--grooming {
  background: linear-gradient(90deg, #e67e22, #f39c12);
}

.cat-progress-bar--sleeping {
  background: linear-gradient(90deg, #3498db, #2980b9);
}

/* Эффекты при наведении */
.cat:hover {
  transform: scale(1.1);
  filter: brightness(1.1);
}

.cat:hover .cat-eye {
  background: #e74c3c;
  animation: eyeBlink 0.3s ease-in-out;
}

@keyframes eyeBlink {
  0%, 100% { height: 10px; }
  50% { height: 2px; }
}

.cat:hover .cat-ear {
  transform: rotate(0deg);
  transition: transform 0.3s ease;
}

.cat:hover .cat-whisker {
  background: #ecf0f1;
  transition: background 0.3s ease;
}

/* Адаптивность */
@media (max-width: 768px) {
  .cat {
    width: 60px;
    height: 45px;
  }
  
  .cat-head {
    width: 35px;
    height: 25px;
    top: -10px;
  }
  
  .cat-tail {
    width: 25px;
    right: -20px;
  }
  
  .cat-whiskers {
    width: 40px;
  }
  
  .cat-whisker {
    width: 12px;
  }
}

/* Темная тема */
@media (prefers-color-scheme: dark) {
  .cat-body,
  .cat-head {
    background: #34495e;
  }
  
  .cat-body::before,
  .cat-head::before,
  .cat-tail::before {
    background: 
      linear-gradient(90deg, transparent 0%, transparent 20%, #2c3e50 20%, #2c3e50 25%, transparent 25%, transparent 45%, #2c3e50 45%, #2c3e50 50%, transparent 50%, transparent 70%, #2c3e50 70%, #2c3e50 75%, transparent 75%, transparent 100%);
  }
  
  .cat-eye {
    background: #ecf0f1;
  }
  
  .cat-eye::before {
    background: #34495e;
  }
  
  .cat-paw,
  .cat-paw-grooming {
    background: #34495e;
  }
  
  .cat-tail {
    background: #34495e;
  }
  
  .cat-tail-tip {
    background: #34495e;
  }
  
  .cat-ear {
    border-bottom-color: #34495e;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/ui/CatAnimation/CatAnimation.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,SAAS;EACT;gPAC8O;EAC9O,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;;;;;;;;;;;;GAYG;;AAEH,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,wCAAwC;AACxC;EACE,8CAA8C;AAChD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW,yBAAyB,EAAE;EACtC,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,wBAAwB,EAAE;AAClC;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,8CAA8C;EAC9C;qBACmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB,oBAAoB,EAAE;EACtC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;;;;;;;GAOG;;AAEH;;;;;;;GAOG;;AAEH;;;;;8EAK8E;;AAE9E,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,uBAAuB,EAAE;AACjC;;AAEA,sBAAsB;AACtB;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,0BAA0B;AAC1B;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,uBAAuB,EAAE;AACjC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,WAAW,WAAW,EAAE;EACxB,MAAM,YAAY,EAAE;AACtB;;AAEA,yBAAyB;AACzB;;;;;;;;;;;;;;;GAeG;;AAEH,kBAAkB;AAClB;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,WAAW,WAAW,EAAE;EACxB,MAAM,WAAW,EAAE;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,0BAA0B;AAC1B;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,WAAW,EAAE;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,gBAAgB;AAChB;EACE;;IAEE,mBAAmB;EACrB;;EAEA;;;IAGE;kPAC8O;EAChP;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* Контейнер для кошки */\r\n.cat-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  pointer-events: none;\r\n  z-index: 9999;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Основной элемент кошки */\r\n.cat {\r\n  position: absolute;\r\n  width: 80px;\r\n  height: 60px;\r\n  pointer-events: auto;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  transform-origin: center;\r\n}\r\n\r\n/* Состояние \"показывает сообщение\" - кошка более спокойная */\r\n.cat--showing-message {\r\n  cursor: default;\r\n  pointer-events: none !important;\r\n}\r\n\r\n.cat--showing-message .cat-body {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.cat--showing-message .cat-head {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Тело кошки - минималистичный дизайн */\r\n.cat-body {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #2c3e50;\r\n  border-radius: 30px 30px 20px 20px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  position: relative;\r\n  /* overflow: hidden; */\r\n}\r\n\r\n/* Полоски на теле */\r\n.cat-body::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    linear-gradient(90deg, transparent 0%, transparent 20%, #34495e 20%, #34495e 25%, transparent 25%, transparent 45%, #34495e 45%, #34495e 50%, transparent 50%, transparent 70%, #34495e 70%, #34495e 75%, transparent 75%, transparent 100%);\r\n  background-size: 100% 8px;\r\n  background-position: 0 15px;\r\n  opacity: 0.6;\r\n}\r\n\r\n/* Голова кошки */\r\n.cat-head {\r\n  position: absolute;\r\n  top: -12px;\r\n  left: 50%;\r\n  transform: translateX(-100%);\r\n  width: 45px;\r\n  height: 35px;\r\n  background: #2c3e50;\r\n  border-radius: 22px 22px 18px 18px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  position: relative;\r\n  /* overflow: hidden; */\r\n}\r\n\r\n/* Полоски на голове */\r\n/* .cat-head::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    linear-gradient(90deg, transparent 0%, transparent 30%, #34495e 30%, #34495e 35%, transparent 35%, transparent 65%, #34495e 65%, #34495e 70%, transparent 70%, transparent 100%);\r\n  background-size: 100% 6px;\r\n  background-position: 0 8px;\r\n  opacity: 0.6;\r\n} */\r\n\r\n/* Уши кошки - треугольные */\r\n.cat-ears {\r\n  position: absolute;\r\n  top: -15px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 50px;\r\n  height: 25px;\r\n}\r\n\r\n.cat-ear {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 12px solid transparent;\r\n  border-right: 12px solid transparent;\r\n  border-bottom: 22px solid #34495e;\r\n  border-radius: 2px;\r\n  transition: transform 0.3s ease;\r\n  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3); */\r\n  filter: brightness(1.1);\r\n}\r\n\r\n.cat-ear::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 3px;\r\n  left: -8px;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 8px solid transparent;\r\n  border-right: 8px solid transparent;\r\n  border-bottom: 14px solid #e74c3c;\r\n  border-radius: 1px;\r\n}\r\n\r\n.cat-ear--left {\r\n  left: 2px;\r\n  transform: rotate(-25deg);\r\n}\r\n\r\n.cat-ear--right {\r\n  right: 2px;\r\n  transform: rotate(25deg);\r\n}\r\n\r\n/* Анимация ушек при hover */\r\n.cat:hover .cat-ear--left {\r\n  transform: rotate(-30deg) scale(1.1);\r\n}\r\n\r\n.cat:hover .cat-ear--right {\r\n  transform: rotate(30deg) scale(1.1);\r\n}\r\n\r\n/* Анимация ушек при разных состояниях */\r\n.cat--grooming .cat-ear--left {\r\n  animation: earTwitch 0.5s ease-in-out infinite;\r\n}\r\n\r\n.cat--grooming .cat-ear--right {\r\n  animation: earTwitchRight 0.5s ease-in-out infinite 0.25s;\r\n}\r\n\r\n.cat--sleeping .cat-ear--left {\r\n  transform: rotate(-15deg);\r\n}\r\n\r\n.cat--sleeping .cat-ear--right {\r\n  transform: rotate(15deg);\r\n}\r\n\r\n@keyframes earTwitch {\r\n  0%, 100% { transform: rotate(-25deg); }\r\n  50% { transform: rotate(-35deg); }\r\n}\r\n\r\n@keyframes earTwitchRight {\r\n  0%, 100% { transform: rotate(25deg); }\r\n  50% { transform: rotate(35deg); }\r\n}\r\n\r\n/* Лицо кошки */\r\n.cat-face {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 30px;\r\n  height: 18px;\r\n}\r\n\r\n/* Глаза кошки - большие и круглые */\r\n.cat-eyes {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 12px;\r\n}\r\n\r\n.cat-eye {\r\n  position: absolute;\r\n  width: 10px;\r\n  height: 10px;\r\n  background: #ecf0f1;\r\n  border-radius: 50%;\r\n  top: 1px;\r\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\r\n  /* position: relative;\r\n  overflow: hidden; */\r\n}\r\n\r\n.cat-eye::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 2px;\r\n  width: 4px;\r\n  height: 4px;\r\n  background: #2c3e50;\r\n  border-radius: 50%;\r\n  animation: blink 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes blink {\r\n  0%, 90%, 100% { transform: scaleY(1); }\r\n  95% { transform: scaleY(0.1); }\r\n}\r\n\r\n.cat-eye--left {\r\n  left: 2px;\r\n}\r\n\r\n.cat-eye--right {\r\n  right: 2px;\r\n}\r\n\r\n/* Нос кошки */\r\n.cat-nose {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 4px;\r\n  height: 3px;\r\n  background: #e74c3c;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Рот кошки */\r\n.cat-mouth {\r\n  position: absolute;\r\n  top: 12px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 6px;\r\n  height: 2px;\r\n  border-bottom: 1px solid #34495e;\r\n  border-radius: 0 0 3px 3px;\r\n}\r\n\r\n/* Усы кошки - тонкие линии */\r\n/* .cat-whiskers {\r\n  position: absolute;\r\n  top: 6px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 50px;\r\n  height: 15px;\r\n} */\r\n\r\n/* .cat-whisker {\r\n  position: absolute;\r\n  width: 15px;\r\n  height: 1px;\r\n  background: #bdc3c7;\r\n  border-radius: 1px;\r\n  transition: all 0.3s ease;\r\n} */\r\n\r\n/* .cat-whisker--left-1 { top: 2px; left: -12px; transform: rotate(-15deg); }\r\n.cat-whisker--left-2 { top: 7px; left: -12px; transform: rotate(-5deg); }\r\n.cat-whisker--left-3 { top: 12px; left: -12px; transform: rotate(5deg); }\r\n.cat-whisker--right-1 { top: 2px; right: -12px; transform: rotate(15deg); }\r\n.cat-whisker--right-2 { top: 7px; right: -12px; transform: rotate(5deg); }\r\n.cat-whisker--right-3 { top: 12px; right: -12px; transform: rotate(-5deg); } */\r\n\r\n/* Хвост кошки - изогнутый */\r\n.cat-tail {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: -22px;\r\n  width: 30px;\r\n  height: 6px;\r\n  background: #2c3e50;\r\n  border-radius: 3px;\r\n  transform-origin: left center;\r\n  animation: tailWag 2s ease-in-out infinite;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* .cat-tail::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    linear-gradient(90deg, transparent 0%, transparent 30%, #34495e 30%, #34495e 35%, transparent 35%, transparent 65%, #34495e 65%, #34495e 70%, transparent 70%, transparent 100%);\r\n  background-size: 100% 3px;\r\n  background-position: 0 2px;\r\n  opacity: 0.6;\r\n  border-radius: 3px;\r\n} */\r\n\r\n.cat-tail-tip {\r\n  position: absolute;\r\n  right: -4px;\r\n  top: -2px;\r\n  width: 6px;\r\n  height: 6px;\r\n  background: #2c3e50;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Лапы кошки */\r\n.cat-paws {\r\n  position: absolute;\r\n  bottom: -4px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 8px;\r\n}\r\n\r\n.cat-paw {\r\n  position: absolute;\r\n  width: 8px;\r\n  height: 6px;\r\n  background: #2c3e50;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.cat-paw--front-left {\r\n  left: 15px;\r\n  bottom: 0;\r\n}\r\n\r\n.cat-paw--front-right {\r\n  left: 25px;\r\n  bottom: 0;\r\n}\r\n\r\n.cat-paw--back-left {\r\n  right: 25px;\r\n  bottom: 0;\r\n}\r\n\r\n.cat-paw--back-right {\r\n  right: 15px;\r\n  bottom: 0;\r\n}\r\n\r\n/* Анимация виляния хвостом */\r\n@keyframes tailWag {\r\n  0%, 100% { transform: rotate(0deg); }\r\n  50% { transform: rotate(8deg); }\r\n}\r\n\r\n/* Состояние сидения */\r\n.cat--sitting {\r\n  animation: sitting 4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes sitting {\r\n  0%, 100% { transform: translateY(0px); }\r\n  50% { transform: translateY(-2px); }\r\n}\r\n\r\n/* Состояние вылизывания */\r\n.cat--grooming {\r\n  animation: grooming 1.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes grooming {\r\n  0%, 100% { transform: rotate(0deg); }\r\n  25% { transform: rotate(-8deg); }\r\n  75% { transform: rotate(8deg); }\r\n}\r\n\r\n/* Язык для вылизывания */\r\n.cat-tongue {\r\n  position: absolute;\r\n  top: 14px;\r\n  left: 25%;\r\n  transform: translateX(-100%);\r\n  width: 4px;\r\n  height: 6px;\r\n  background: #e91e63;\r\n  border-radius: 0 0 2px 2px;\r\n  animation: tongueLick 0.6s ease-in-out infinite;\r\n}\r\n\r\n@keyframes tongueLick {\r\n  0%, 100% { height: 6px; }\r\n  50% { height: 10px; }\r\n}\r\n\r\n/* Лапа для вылизывания */\r\n/* .cat-paw-grooming {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 6px;\r\n  width: 6px;\r\n  height: 8px;\r\n  background: #2c3e50;\r\n  border-radius: 3px;\r\n  animation: pawGroom 1.5s ease-in-out infinite;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@keyframes pawGroom {\r\n  0%, 100% { transform: rotate(0deg); }\r\n  50% { transform: rotate(45deg); }\r\n} */\r\n\r\n/* Состояние сна */\r\n.cat--sleeping {\r\n  animation: sleeping 5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes sleeping {\r\n  0%, 100% { transform: scale(1); }\r\n  50% { transform: scale(1.05); }\r\n}\r\n\r\n/* Глаза во время сна */\r\n.cat--sleeping .cat-eye {\r\n  background: #95a5a6;\r\n  border-radius: 50% 50% 0 0;\r\n  height: 5px;\r\n  animation: eyeSleep 3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes eyeSleep {\r\n  0%, 100% { height: 5px; }\r\n  50% { height: 2px; }\r\n}\r\n\r\n/* ZZZ для сна */\r\n.cat-sleeping {\r\n  position: absolute;\r\n  top: -25px;\r\n  right: -8px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: #3498db;\r\n  animation: zzzFloat 2s ease-in-out infinite;\r\n}\r\n\r\n.cat-zzz {\r\n  position: absolute;\r\n  animation: zzzFloat 2s ease-in-out infinite;\r\n}\r\n\r\n.cat-zzz--2 {\r\n  animation-delay: 0.5s;\r\n  top: -15px;\r\n  right: 5px;\r\n}\r\n\r\n.cat-zzz--3 {\r\n  animation-delay: 1s;\r\n  top: -8px;\r\n  right: 15px;\r\n}\r\n\r\n@keyframes zzzFloat {\r\n  0%, 100% { \r\n    opacity: 0.6;\r\n    transform: translateY(0px) rotate(0deg);\r\n  }\r\n  50% { \r\n    opacity: 1;\r\n    transform: translateY(-5px) rotate(5deg);\r\n  }\r\n}\r\n\r\n/* Состояние бега */\r\n.cat--running {\r\n  animation: running 0.3s ease-in-out infinite;\r\n}\r\n\r\n@keyframes running {\r\n  0%, 100% { transform: translateY(0px); }\r\n  25% { transform: translateY(-3px); }\r\n  75% { transform: translateY(2px); }\r\n}\r\n\r\n/* Анимация лап при беге */\r\n.cat--running .cat-paw {\r\n  animation: pawRun 0.3s ease-in-out infinite;\r\n}\r\n\r\n.cat--running .cat-paw--front-left,\r\n.cat--running .cat-paw--back-right {\r\n  animation-delay: 0.15s;\r\n}\r\n\r\n@keyframes pawRun {\r\n  0%, 100% { transform: translateY(0px); }\r\n  50% { transform: translateY(-2px); }\r\n}\r\n\r\n/* Прогресс-бары */\r\n.cat-progress {\r\n  position: absolute;\r\n  top: -12px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 50px;\r\n  height: 4px;\r\n  background: rgba(0, 0, 0, 0.1);\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n}\r\n\r\n.cat-progress-bar {\r\n  height: 100%;\r\n  border-radius: 2px;\r\n  transition: width 0.1s ease;\r\n}\r\n\r\n.cat-progress-bar--grooming {\r\n  background: linear-gradient(90deg, #e67e22, #f39c12);\r\n}\r\n\r\n.cat-progress-bar--sleeping {\r\n  background: linear-gradient(90deg, #3498db, #2980b9);\r\n}\r\n\r\n/* Эффекты при наведении */\r\n.cat:hover {\r\n  transform: scale(1.1);\r\n  filter: brightness(1.1);\r\n}\r\n\r\n.cat:hover .cat-eye {\r\n  background: #e74c3c;\r\n  animation: eyeBlink 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes eyeBlink {\r\n  0%, 100% { height: 10px; }\r\n  50% { height: 2px; }\r\n}\r\n\r\n.cat:hover .cat-ear {\r\n  transform: rotate(0deg);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.cat:hover .cat-whisker {\r\n  background: #ecf0f1;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .cat {\r\n    width: 60px;\r\n    height: 45px;\r\n  }\r\n  \r\n  .cat-head {\r\n    width: 35px;\r\n    height: 25px;\r\n    top: -10px;\r\n  }\r\n  \r\n  .cat-tail {\r\n    width: 25px;\r\n    right: -20px;\r\n  }\r\n  \r\n  .cat-whiskers {\r\n    width: 40px;\r\n  }\r\n  \r\n  .cat-whisker {\r\n    width: 12px;\r\n  }\r\n}\r\n\r\n/* Темная тема */\r\n@media (prefers-color-scheme: dark) {\r\n  .cat-body,\r\n  .cat-head {\r\n    background: #34495e;\r\n  }\r\n  \r\n  .cat-body::before,\r\n  .cat-head::before,\r\n  .cat-tail::before {\r\n    background: \r\n      linear-gradient(90deg, transparent 0%, transparent 20%, #2c3e50 20%, #2c3e50 25%, transparent 25%, transparent 45%, #2c3e50 45%, #2c3e50 50%, transparent 50%, transparent 70%, #2c3e50 70%, #2c3e50 75%, transparent 75%, transparent 100%);\r\n  }\r\n  \r\n  .cat-eye {\r\n    background: #ecf0f1;\r\n  }\r\n  \r\n  .cat-eye::before {\r\n    background: #34495e;\r\n  }\r\n  \r\n  .cat-paw,\r\n  .cat-paw-grooming {\r\n    background: #34495e;\r\n  }\r\n  \r\n  .cat-tail {\r\n    background: #34495e;\r\n  }\r\n  \r\n  .cat-tail-tip {\r\n    background: #34495e;\r\n  }\r\n  \r\n  .cat-ear {\r\n    border-bottom-color: #34495e;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
